export default function popModal () {
  return {
    type: 'POP_MODAL',
  };
}



// WEBPACK FOOTER //
// ./lib/rlink-router/actions/popModal.js